import KpiCard from './KpiCard'
import type { RocksStats } from '../../types'

function fmtPct(p: number): string {
  return p % 1 === 0 ? `${p}%` : p.toFixed(1) + '%'
}

export default function RocksKpiCard({ stats, teamId }: { stats: RocksStats; teamId: number }) {
  const avg = stats.average_percent
  const color = stats.total === 0 ? 'neutral' : avg >= 80 ? 'green' : avg >= 50 ? 'amber' : 'red'

  const subtitle = stats.total > 0
    ? `${stats.count_at_100} of ${stats.total} at 100%`
    : 'No rocks this quarter'

  return (
    <KpiCard
      label="F.A.S.T. Rocks"
      value={stats.total > 0 ? `${fmtPct(avg)} avg` : '0 rocks'}
      subtitle={subtitle}
      href={`/teams/${teamId}/rocks`}
      statusColor={color}
      icon={
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z" />
          <path d="M2 17l10 5 10-5" />
          <path d="M2 12l10 5 10-5" />
        </svg>
      }
    />
  )
}
